import { render, staticRenderFns } from "./template2.vue?vue&type=template&id=259a8c2e&scoped=true"
import script from "./template2.vue?vue&type=script&lang=js"
export * from "./template2.vue?vue&type=script&lang=js"
import style0 from "./template2.vue?vue&type=style&index=0&id=259a8c2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a8c2e",
  null
  
)

export default component.exports